import { render, staticRenderFns } from "./Captcha.vue?vue&type=template&id=c51258f0&scoped=true&"
import script from "./Captcha.vue?vue&type=script&lang=js&"
export * from "./Captcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51258f0",
  null
  
)

export default component.exports